import { AddProductErrorCode } from "@jti/magento";
const errorMessagesMap = [
    {
        magentoErrorKey: "Please specify product option",
        translationKey: "productdetails.addproduct.error.options",
    },
    {
        magentoErrorKey: `Product that you are trying to add is not available`,
        translationKey: "productdetails.addproduct.error.unavailable",
    },
    {
        magentoErrorKey: `The requested qty is not available`,
        translationKey: "productdetails.flavours.outOfStock",
    },
    {
        magentoErrorKey: "Product quantity limit exceeded",
        translationKey: "productdetails.addproduct.error.limit",
    },
    {
        magentoErrorKey: "Please select all required options",
        translationKey: "productdetails.addproduct.error.required",
    },
    {
        magentoErrorKey: "Invalid amount of bundle product options selected",
        translationKey: "productdetails.addproduct.error.bundleAmount",
    },
    {
        magentoErrorKey: "Provided quantity for the selection are empty or invalid",
        translationKey: "productdetails.addproduct.error.bundleAmount",
    },
    {
        magentoErrorKey: "Order limit exceeded",
        translationKey: "productdetails.addproduct.error.orderLimit",
    },
];
const errorCodesMessagesMap = {
    [AddProductErrorCode.PRODUCT_EXISTS_IN_SUBSCRIPTION]: "productdetails.addproduct.error.already_in_subscription",
};
export const parseAddToCartErrorMessage = (data) => {
    var _a, _b;
    const currentErrorMessage = (_a = data === null || data === void 0 ? void 0 : data.message) === null || _a === void 0 ? void 0 : _a.toString().toLowerCase();
    const errorCode = (_b = data.errorCodes) === null || _b === void 0 ? void 0 : _b[0];
    const messageFromErrorCode = errorCodesMessagesMap[errorCode];
    if (messageFromErrorCode) {
        return messageFromErrorCode;
    }
    if (currentErrorMessage) {
        const currentMessage = errorMessagesMap.find((element) => currentErrorMessage.indexOf(element.magentoErrorKey.toLowerCase()) !== -1);
        if (currentMessage) {
            return currentMessage.translationKey;
        }
    }
    return "productdetails.addproduct.error.general";
};
//# sourceMappingURL=parseAddToCartErrorMessage.js.map